<template>
  <div>
    <b-row style="color:red;font-size:15pt;">
      이메뉴에 api response 항목에 이름 휴대폰 마케팅 수신동의값 필요 <br/>
      탈퇴 api 필요<br/>
      비밀번호 초기화시 메일 전송 필요 oldPassword 점검
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.user-detail')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="회원정보">
          <b-form @submit.prevent="onSubmitEdit">
            <b-row>
              <b-colxx sm="12">
                <b-form-group label-cols="2" horizontal label="아이디" class="error-l-250">
                  <b-form-input v-model="username" readonly></b-form-input>
                  <b-form-invalid-feedback class="d-block" v-if="!$v.username.required">{{$t('user.required-id')}}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-colxx>

              <b-colxx sm="12">
                <b-form-group label-cols="2" horizontal label="이름" class="error-l-250">
                  <b-form-input v-model="fullName"></b-form-input>
                  <b-form-invalid-feedback class="d-block" v-if="!$v.fullName.required">{{$t('user.required-name')}}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-colxx>

              <b-colxx sm="12">
                <b-form-group label-cols="2" horizontal label="비밀번호" class="error-l-250">
                  <b-button @click="resetPassword" variant="primary">비밀번호 초기화</b-button>
                </b-form-group>
              </b-colxx>

              <b-colxx sm="12">
                <b-form-group label-cols="2" horizontal label="휴대폰" class="error-l-250">
                  <b-form-input v-model="phoneNumber"></b-form-input>
                  <b-form-invalid-feedback class="d-block" v-if="!$v.phoneNumber.required">{{$t('user.required-phone')}}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-colxx>

              <b-colxx sm="12">
                <b-row>
                  <b-col cols="6">
                    <b-form-group label-cols="5" horizontal label="마케팅 수신동의">
                      <b-form-checkbox v-model="emailAgree">이메일 수신동의</b-form-checkbox>
                    </b-form-group >
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="0" horizontal>
                      <b-form-checkbox v-model="smsAgree">이메일 수신동의</b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-colxx>
            </b-row>

            <b-button @click="onCancel" variant="outline-primary" size="md">취소</b-button>
            <b-button type="submit" variant="primary" size="md">저장</b-button>
            <b-button @click="unRegister" variant="success" size="md">탈퇴</b-button>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>

  import {
    mapGetters,
    mapActions
  } from "vuex";

  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import {
    validationMixin
  } from "vuelidate";
  import api from '../../constants/api'

  const {
    required,
    maxLength,
    minLength,
    numeric,
    email
  } = require("vuelidate/lib/validators");


  export default {
    components: {
      'v-select': vSelect,
    },
    props: [],
    mixins: [validationMixin],
    validations: {
      username: {
        required
      },
      fullName: {
        required
      },
      phoneNumber: {
        required,
        numeric
      }

    },
    data() {
      return {
        username: this.$route.params.id,
        fullName: '',
        phoneNumber: '',
        emailAgree: false,
        smsAgree: false
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
      this.loadData()
    },
    methods: {
      onCancel() {
        this.$router.back()
      },
      loadData() {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
        const params = {
          username: this.username
        }

        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {

          } else {
            throw 400
          }
        }).catch(err => {

        })
      },
      unRegister() {
        if (confirm('탈퇴처리 하시겠습니까?')) {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.unregister)
          const params = {
            username: this.username
          }
          this.$http.post(reqURL, params,{
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if (res.data.code === "OK") {
              alert('적용하였습니다.')
              this.$router.back()
            } else {
              throw 400
            }
          }).catch(err => {
            alert(err.response.data.message);
          })
        }
      },
      onSubmitEdit() {
        this.$v.touch();
        if (!this.$v.invalid) {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
          const params = {
            username: this.username

          }

          this.$http.post(reqURL, params ,{
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if (res.data.code === "OK") {

            } else {
              throw 400
            }
          }).catch(err => {
            alert(err.response.data.message);

          })

        }
      },
      resetPassword() {
        let tempPassword = this.randomString(7)
        if (confirm('비밀번호를 \"' + tempPassword + '\"로 초기화 하시겠습니까?')) {

          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.changePassword)
          const params = {
            username: this.username,
            oldPassword: "",
            newPassword: ""
          }

          this.$http.post(reqURL, params,{
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if (res.data.code === "OK") {

              this.$notify("success", "초기화", "비밀번호가 초기화 되었습니다", {duration: 3000, permanent: false})
            } else {
              throw 400
            }
          }).catch(err => {
            alert(err.response.data.message);

          })

        }
      },
      randomString(len) {
        let password = '';
        let CharacterSet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        for (let i = 0; i < len; i++) {
          password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
        }
        return password
      }
    }
    , watch: {}
  }
</script>
